module.exports = __webpack_public_path__ + "img/gpsCalibrate.f0331374.gif";